"use client";

import { c as _c } from "react/compiler-runtime";
import { useEmoji } from "@/contexts/EmojiContext";
interface ReactionEmojiPreviewProps {
  readonly rawId: string;
}
export default function ReactionEmojiPreview(t0) {
  const $ = _c(11);
  const {
    rawId
  } = t0;
  const {
    findCustomEmoji,
    findNativeEmoji
  } = useEmoji();
  let t1;
  if ($[0] !== findCustomEmoji || $[1] !== rawId) {
    t1 = findCustomEmoji(rawId);
    $[0] = findCustomEmoji;
    $[1] = rawId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const custom = t1;
  if (custom) {
    const t2 = custom.skins[0]?.src;
    let t3;
    if ($[3] !== rawId || $[4] !== t2) {
      t3 = <div className="tw-relative tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-bg-iron-950 tw-p-1.5 tw-ring-1 tw-ring-inset tw-ring-iron-800"><img src={t2} alt={rawId} className="tw-max-h-5 tw-max-w-5 tw-object-contain" /></div>;
      $[3] = rawId;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  if ($[6] !== findNativeEmoji || $[7] !== rawId) {
    t2 = findNativeEmoji(rawId);
    $[6] = findNativeEmoji;
    $[7] = rawId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const native = t2;
  if (native) {
    const t3 = native.skins[0]?.native;
    let t4;
    if ($[9] !== t3) {
      t4 = <div className="tw-relative tw-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-bg-iron-950 tw-p-1.5 tw-ring-1 tw-ring-inset tw-ring-iron-800"><span className="tw-flex tw-max-h-5 tw-max-w-5 tw-items-center tw-justify-center tw-text-xl tw-leading-none">{t3}</span></div>;
      $[9] = t3;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  return null;
}